import { gql } from "graphql-tag";

/**
 * Fetches group devices using group id
 *
 * variable example
 * {"groupId": "16383"}
 */
export const GET_GroupDevices = gql`
  query GET_GroupDevices($groupDevices: String!) {
    devices: PosDeviceList(where: $groupDevices) {
      id: Id
      groupId: GroupId
      createdAt: CreatedAt
      deviceUid: DeviceUid
      name: DeviceName
      locationId: LocationId
      cashLocation: CashLocationRead {
        Id
        Name
        Canceled
        DeviceType
      }
      fiskalyCashRegisterId: FiskalyCashRegisterId
      status: Status
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 * Fetch location attached to the device by its hardware uuid
 *
 * variable example
 * {"groupId": "16383"}
 */
export const GET_DeviceLocation = gql`
  query GET_DeviceLocation($condition: String!) {
    devices: PosDeviceList(where: $condition) {
      id: Id
      status: Status
      groupId: GroupId
      createdAt: CreatedAt
      deviceUid: DeviceUid
      name: DeviceName
      hardwareUid: HardwareUid
      locationId: LocationId
      fiskalyCashRegisterId: FiskalyCashRegisterId
      cashLocationRead: CashLocationRead {
        id: Id
        name: Name
      }
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 * Fetches group cashLocations using group id
 *
 * variable example
 * {"groupId": "16383"}
 */
export const GET_GroupCashLocations = gql`
  query GET_GroupCashLocations($groupLocations: String!) {
    cashLocations: CashLocationList(where: $groupLocations) {
      id: Id
      name: Name
      groupId: GroupId
      deviceType: DeviceType
      canceled: Canceled
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;

/**
 * Fetches the last cashfloat of the device
 */
export const GET_LastCashFloat = gql`
  query GET_LastCashFloat($condition: String!) {
    CashFloatList(where: $condition, sort: "-SeqId", limit: 1) {
      Id
      SeqId
      DeviceId
      GroupRead {
        groupUuid: Uuid
      }
    }
  }
`;
